// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:ab460d84-d95d-4eae-bf37-1a309b1dc22e",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_cPDACSNCV",
    "aws_user_pools_web_client_id": "7331trrui0skh9qa071tqhni78",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://v7dfywfyp5effoxwi7h574t6t4.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_content_delivery_bucket": "amplify-notetaker-20200308200240-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "http://amplify-notetaker-20200308200240-hostingbucket-prod.s3-website-eu-west-1.amazonaws.com"
};


export default awsmobile;
